import animation from '@helpers/animation';
import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import { ReactComponent as SvgChevron } from '@img/icons/chevron-down.svg';
import { ReactComponent as SvgClose } from '@img/icons/cross-solid-icon.svg';
import { ReactComponent as SvgTick } from '@img/icons/tick.svg';
import styled, { css } from 'styled-components';
import Select from '../Selectors/Select/Select';
const Container = styled.section `
  ${setCssVar('accentColor', brand.sage.sageDark)};
  ${setCssVar('bgColor', brand.grey.greyLight)};
  ${setCssVar('bgColorAlt', brand.white)};
  ${setCssVar('fgColor', brand.black)};
  ${setCssVar('fgColorAlt', brand.black)};


  display: flex;
  flex-wrap: wrap;
  align-items: center;

  color: ${cssVar('fgColor')};

  @media ${until(Device.TabletLarge)} {
    display: none;
  }

  @media ${from(Device.TabletLarge)} {
    padding: 80px 0 0;
  }

`;
const Title = styled.p `
  display: block;
  flex: 0 0 auto;
  ${fonts.matter.medium};
  font-size: 16px;
  line-height: 24px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
`;
const SortTitle = styled(Title) `
`;
const FilterList = styled.div `
  display: flex;
  flex: 1 1 auto;
`;
const Filter = styled.div `
  display: block;
  flex: 1 1 auto;
  margin-left: 16px;
  max-width: 248px;

  @media ${from(Device.Desktop)} {
    margin-left: 30px;
  }
`;
const MultiDropdown = styled.div `
  display: block;
  width: 100%;
`;
const FilterDropdown = styled(Select) `
  display: block;
  width: 100%;
`;
const FilterHolder = styled.span ``;
const CheckboxSection = styled.div `
  display: flex;
  align-items: center;
  margin-right: 60px;
`;
const CheckboxArea = styled.div `
  display: flex;
  
`;
const CheckboxAreaContainer = styled.div `
  position: relative;
  margin-left: 30px; 
`;
const Chevron = styled(SvgChevron) `
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.3s ${animation.sharp};
  height: 6px;
  width: 14px;

  @media (prefers-reduced-motion: reduce)  {
    transition: none;
  }
`;
const CheckboxAreaLabel = styled.button `
  ${fonts.matter.medium};
  font-size: 14px;
  line-height: 42px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: left;
  border-radius: 4px 4px 0 0;
  color: ${brand.sage.sageLight};
  flex: 1 0 100%;
  border: 1px solid ${brand.sage.sageLight};
  padding: 4px 40px 4px 15px;
  background: transparent;
  min-width: 200px;
  position: relative;

  &:hover,
  &:focus {
    border: 1px solid ${brand.sage.sageDark};
    color: ${brand.sage.sageDark};
  }

  ${({ active }) => active &&
    css `
      ${Chevron} {
        transform: translateY(-50%) rotate(180deg);
      }
    `}
`;
const CheckboxAreaItems = styled.div `
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  background-color: ${brand.white};
  min-width: 100%;
  border: 1px solid ${brand.sage.sageLight};
  border-top: none;
  display: none;

  ${({ active }) => active &&
    css `
      display: block;
    `}
`;
const CheckBoxContainer = styled.div `
  position: relative;
  display: block;
  width: auto;

  & + & {
    margin-top: 15px;
  }

  @media ${from(Device.Tablet)} {
    & + & {
      margin-top: 0;
      margin-left: 56px;
    }
  }
`;
const CheckboxItemContainer = styled.div `  
`;
const CheckboxInput = styled.input `
  ${srOnly}

  &:focus {
    background-color: ${brand.grey.greyLight};

    + span {
      background-color: ${brand.grey.greyLight};
    }
  }
`;
const Tick = styled(SvgTick) `
  position: absolute;
  right: 15px;
  top: 15px;
  color: ${brand.sage.sageLight};
  width: 18px;
  opacity: 0;
  z-index: 1;
`;
const CheckboxText = styled.span `
  display: block;
  margin: 0;
  padding: 15px 32px 15px 15px ;

  ${CheckboxInput}:checked + & {
    ${Tick} {
      opacity: 1;
    }
  }
`;
const CheckboxItem = styled.label `
  position: relative;
  display: block;
  cursor: pointer;

  &:hover {    
    ${CheckboxText} {
      background-color: ${brand.grey.greyLight};
    }
  }
`;
const SelectedButtons = styled.div `
  margin-top: 30px;
  flex: 1 0 100%;
`;
const SelectedBtn = styled.button `
  background-color: transparent;
  border: none;
  color: ${brand.black};
  margin-right: 22px;
  padding-right: 0;
  padding-left: 0;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: 2px;
    left: 0;
    height: 1px;
    width: 100%;
    background-color: currentColor;
    transform: scaleX(0);
    transition: transform 0.3s ${animation.sharp};
  }

  &:focus {
    &:after {
      transform: scaleX(0.5);
    }
  }

  &:hover {
    &:after {
      transform: scaleX(1);
    }
  }


  &:last-child {
    color: ${brand.sage.sageLight};
  }
`;
const Close = styled(SvgClose) `
  height: 11px;
  width: 11px;
  display: inline-block;
  vertical-align: middle;
`;
const SelectedBtnText = styled.span `
  margin-left: 10px;
  margin-right: 0;
  text-transform: uppercase;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.08em;
  vertical-align: middle;
`;
export default {
    CheckboxArea,
    CheckboxAreaContainer,
    CheckboxAreaItems,
    CheckboxAreaLabel,
    CheckBoxContainer,
    CheckboxInput,
    CheckboxItem,
    CheckboxItemContainer,
    CheckboxSection,
    CheckboxText,
    Chevron,
    Close,
    Container,
    Filter,
    FilterDropdown,
    FilterHolder,
    FilterList,
    MultiDropdown,
    SelectedBtn,
    SelectedBtnText,
    SelectedButtons,
    SortTitle,
    Tick,
    Title,
};
